// extracted by mini-css-extract-plugin
module.exports = {"flex_container":"form_flex_container__3Mfcj","textarea":"form_textarea__1OCEM","btn_wrapper":"form_btn_wrapper__2l8NG"};